import type { AssetFileRef } from "./types";

import { AssetThumb } from "../AssetThumb";
import { formatFileSize } from "./format-file-size";

type AssetFileTileProps = {
  file: AssetFileRef;
  onPreview: (attachmentId: number) => void;
  onRemove?: (attachmentId: number) => void;
};

export function AssetFileTile({
  file,
  onPreview,
  onRemove,
}: AssetFileTileProps) {
  return (
    <div className="min-w-0 animate-in duration-200 fade-in zoom-in-95 motion-reduce:animate-none">
      <AssetThumb file={file} onPreview={onPreview} onRemove={onRemove} />
      <p
        className="mt-md truncate text-[13px] font-medium text-text-primary"
        title={file.name}
      >
        {file.name}
      </p>
      {typeof file.size === "number" ? (
        <p className="text-xs text-text-quaternary">
          {formatFileSize(file.size)}
        </p>
      ) : null}
    </div>
  );
}
